import Image from 'react-bootstrap/Image';

import './Header.css';
import { useContext } from 'react';
import { AppContext } from './AppContextProvider';

const getTitleSuffix = () => window.location.pathname.replace(/\//, '');

export const Header = () => {
  const { app } = useContext(AppContext);

  return (
    <h1 className="Header mt-3 mb-3">
      <Image width={app.theme.logoWidth} src={`/img/${app.theme.logo}`} />
      Support Center {getTitleSuffix()}
    </h1>
  );
};
